import { lazyLoad } from 'utils/loadable';

export const VectorIcon = lazyLoad(
  () => import('./index'),
  module => module.VectorIcon,
);
